import { SERVICE_PAGE_SLUGS } from "../services/contentApi";

export const CMS_SERVICE_PAGES = [
  {
    slug: "design",
    name: "Design",
    description: "UI/UX that connects users with products",
    publicPath: "/design",
    accent: "from-violet-500/20 to-violet-600/5",
    accentBorder: "border-violet-200",
    accentText: "text-violet-700",
    accentDot: "bg-violet-500",
  },
  {
    slug: "development",
    name: "Development",
    description: "High-performance web platforms",
    publicPath: "/development",
    accent: "from-emerald-500/20 to-emerald-600/5",
    accentBorder: "border-emerald-200",
    accentText: "text-emerald-700",
    accentDot: "bg-emerald-500",
  },
  {
    slug: "engineering",
    name: "Engineering",
    description: "Custom software built to scale",
    publicPath: "/engineering",
    accent: "from-sky-500/20 to-sky-600/5",
    accentBorder: "border-sky-200",
    accentText: "text-sky-700",
    accentDot: "bg-sky-500",
  },
  {
    slug: "transformation",
    name: "Transformation",
    description: "Evolve your business through technology",
    publicPath: "/transformation",
    accent: "from-amber-500/20 to-amber-600/5",
    accentBorder: "border-amber-200",
    accentText: "text-amber-700",
    accentDot: "bg-amber-500",
  },
  {
    slug: "ai",
    name: "AI",
    description: "Smart systems powered by data",
    publicPath: "/ai",
    accent: "from-fuchsia-500/20 to-fuchsia-600/5",
    accentBorder: "border-fuchsia-200",
    accentText: "text-fuchsia-700",
    accentDot: "bg-fuchsia-500",
  },
  {
    slug: "infrastructure",
    name: "Cloud & Infrastructure",
    description: "Reliable systems built for scale — includes hosting plans",
    publicPath: "/infrastructure",
    accent: "from-teal-500/20 to-teal-600/5",
    accentBorder: "border-teal-200",
    accentText: "text-teal-700",
    accentDot: "bg-teal-500",
    hasHostingPlans: true,
  },
];

export const CMS_SERVICE_SLUGS = new Set(SERVICE_PAGE_SLUGS);

export const SERVICE_SECTION_LABELS = [
  { key: "development-banner", label: "Banner" },
  { key: "what-we-solve", label: "What we solve" },
  { key: "whats-included", label: "What's included" },
  { key: "hosting-plans", label: "Hosting plans", infrastructureOnly: true },
  { key: "dev-process", label: "Process" },
  { key: "whyus", label: "Why us" },
];

export function isServicePageSlug(slug) {
  return CMS_SERVICE_SLUGS.has(String(slug || "").toLowerCase());
}

export function getServicePageMeta(slug) {
  return CMS_SERVICE_PAGES.find((p) => p.slug === slug) ?? null;
}
